import SectionCard from "components/cms/SectionCard";
import { AreaInput, FileInput, GroupBox, TextInput } from "components/cms/fields";

const BLOCK_TYPES = [
  ["paragraph", "Paragraph"],
  ["heading", "Heading"],
  ["list", "List"],
  ["quote", "Quote"],
  ["image", "Image"],
  ["code", "Code"],
  ["callout", "Callout"],
];

export default function BodyBlocks({
  form,
  setForm,
  setField,
  frMap,
  emptyBlock,
  title = "Body",
  description = "Blocks render in the shared template",
}) {
  const body = form.body || [];

  const addBlock = () => {
    setForm((prev) => ({ ...prev, body: [...(prev.body || []), emptyBlock()] }));
  };

  const removeBlock = (index) => {
    setForm((prev) => ({
      ...prev,
      body: (prev.body || []).filter((_, i) => i !== index),
    }));
  };

  return (
    <SectionCard title={title} description={description}>
      <div className="flex flex-col gap-3">
        {body.map((block, index) => (
          <GroupBox key={`block-${index}`} title={`Block ${index + 1}`}>
            <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
              <select
                className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800"
                value={block.type}
                onChange={(event) => setField(`body.${index}.type`, event.target.value)}
              >
                {BLOCK_TYPES.map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={() => removeBlock(index)}
                className="text-xs text-red-600 hover:underline"
              >
                Remove
              </button>
            </div>

            {block.type === "heading" ? (
              <select
                className="mb-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800"
                value={block.level}
                onChange={(event) => setField(`body.${index}.level`, Number(event.target.value))}
              >
                <option value={2}>Heading 2</option>
                <option value={3}>Heading 3</option>
              </select>
            ) : null}

            {block.type === "list" ? (
              <>
                <select
                  className="mb-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800"
                  value={block.style}
                  onChange={(event) => setField(`body.${index}.style`, event.target.value)}
                >
                  <option value="bullet">Bullets</option>
                  <option value="number">Numbers</option>
                </select>
                <AreaInput
                  label="Items (one per line)"
                  path={`body.${index}.items`}
                  form={form}
                  setField={setField}
                  frMap={frMap}
                  rows={4}
                />
              </>
            ) : null}

            {block.type === "image" ? (
              <>
                <FileInput label="Image" path={`body.${index}.image`} form={form} setField={setField} />
                <TextInput
                  label="Caption"
                  path={`body.${index}.caption`}
                  form={form}
                  setField={setField}
                  frMap={frMap}
                />
              </>
            ) : null}

            {block.type === "code" ? (
              <>
                <TextInput label="Language" path={`body.${index}.language`} form={form} setField={setField} />
                <AreaInput label="Code" path={`body.${index}.code`} form={form} setField={setField} rows={6} />
              </>
            ) : null}

            {block.type === "callout" ? (
              <TextInput
                label="Callout title"
                path={`body.${index}.title`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
            ) : null}

            {block.type === "quote" ||
            block.type === "paragraph" ||
            block.type === "heading" ||
            block.type === "callout" ? (
              <AreaInput
                label={block.type === "heading" ? "Heading" : "Text"}
                path={`body.${index}.text`}
                form={form}
                setField={setField}
                frMap={frMap}
                rows={block.type === "heading" ? 2 : 4}
              />
            ) : null}

            {block.type === "quote" ? (
              <TextInput
                label="Cite"
                path={`body.${index}.cite`}
                form={form}
                setField={setField}
                frMap={frMap}
              />
            ) : null}
          </GroupBox>
        ))}
      </div>
      <button
        type="button"
        onClick={addBlock}
        className="mt-3 rounded-lg border border-purple-200 px-3 py-1.5 text-xs font-medium text-[#6A4CF0]"
      >
        Add block
      </button>
    </SectionCard>
  );
}
